<template>
  <v-content class="login-content">
    <v-container
      fluid
      class="pattern-bg dark fill-height"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="10"
          sm="8"
          md="4"
        >
          <v-img
            src="../assets/logo-unhan.png"
            class="avatar-login"
          />
          <v-card
            flatu
            class="elevation-12 card-login"
          >
            <p class="title-user-login text-uppercase text-center font-weight-bold">
              User Management System
            </p>

            <v-card-text>
              <h3> {{ loadingText }}</h3>
            </v-card-text>

            <div class="text-center pt-2">
              <template>
                <v-btn
                  x-large
                  class="button-login font-weight-bold"
                  :loading="loading"
                  @click="login()"
                >
                  Login with SSO
                </v-btn>
              </template>
            </div>
            <br>
            <div class="text-center pt-2">
              <template>
                <v-btn
                  x-large
                  class="button-logout font-weight-bold"
                  :loading="loading"
                  @click="logout()"
                >
                  Logout from SSO
                </v-btn>
              </template>
            </div>
            <div class="text-center pb-10">
              <template>
                <v-btn
                  text
                  @click="forgotPassword()"
                >
                  Forgot Password?
                </v-btn>
              </template>
            </div>
            <v-snackbar
              v-model="snackbar"
              :color="color"
              :top="true"
            >
              {{ errorMessages }}
              <v-btn
                dark
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import { ssoUrl, siteKey, clientId, clientSecret, frontendUrl } from '../config/env'

  export default {
    components: {
      VueRecaptcha,
    },
    data: function () {
      return {
        sitekey: siteKey,
        errorMessages: 'User Is Not Registered',
        snackbar: false,
        color: 'primary',
        data: {
          grant_type: 'authorization_code',
          code: null,
          redirect_uri: `${frontendUrl}/oauth/code`,
          client_id: clientId,
          client_secret: clientSecret,
        },
        showPassword: false,
        loading: false,
        loadingText: null,
      }
    },
    props: ['code'],
    created () {
      if (this.$route.path === '/logout') {
        this.loadingText = null
        this.loading = false
        this.errorMessages = 'You have been successfully logged out from this application, for security reasons, please also LOGOUT from SSO'
        this.snackbar = true
      } else if (this.code != null) {
        this.loadingText = 'Please wait... Verifying User Account...'
        const code = this.code
        this.$store.dispatch('login', { code })
          .then(() => {
            this.loadingText = null
            const originalUrl = localStorage.getItem('original_url')
            if (originalUrl != null) {
              localStorage.removeItem('original_url')
              this.$router.push(originalUrl)
            } else {
              this.$router.push('/home')
            }
          }).catch(err => {
            if (err.response.status === 500) {
              this.errorMessages = 'User do not have any assigned menu'
            }
            this.loadingText = null
            this.loading = false
            this.snackbar = true
          })
      }
    },
    methods: {
      onVerify: function (response) {
        this.recaptcha = response
        console.log('Verify: ' + response)
      },
      onExpired: function () {
        console.log('Expired')
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      forgotPassword () {
        this.$router.push('/forgot-password')
      },
      login: function () {
        this.$router.push('/cas')
      },
      logout: function () {
        window.location = `${ssoUrl}/cas/logout?service=${frontendUrl}`
      },
    },
    metaInfo () {
      return {
        title: 'Unhan - SSO | Login',
      }
    },
  }
</script>

<style scoped>
  .background-login{
    position: fixed;
    height: 100%;
    left: 0;
    bottom: 0;
    z-index: 1;
  }

  .container-login{
    margin-left: 25%;
    margin-top: -3%;
  }

  .recaptcha {
    margin-top: -4%;
    margin-left: 25%;
  }

  .card-login{
    z-index: 1;
  }

  .avatar-login{
    width: 40%;
    z-index: 2;
    margin-bottom: -15%;
    align-content: center;
    margin-left: 28%;
  }

  .title-user-login{
    padding-top: 15%;
    margin-bottom: -10px;
    color: #393939;
    font-size: 25px;
  }

  .button-login{
    width: 70%;
    height: 50px;
    border-radius: 25px;
    font-size: 1rem;
    outline: none;
    border:none;
    text-transform: uppercase;
    /* background-image:; */
    background-image: linear-gradient(to right, #a30000, #a30000,  #a30000);
    cursor: pointer;
    color: #fff;
    font-family: 'Poppins',sans-serif;
    background-size: 200%;
    transition: .5s;
  }

  .button-logout{
    width: 70%;
    height: 50px;
    border-radius: 25px;
    font-size: 1rem;
    outline: none;
    border:none;
    text-transform: uppercase;
    /* background-image:; */
    background-image: linear-gradient(to right, #a30000, #a30000,  #a30000);
    cursor: pointer;
    color: #fff;
    font-family: 'Poppins',sans-serif;
    background-size: 200%;
    transition: .5s;
  }

  .pattern-bg {
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.33' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
  }

  .button-login:hover{
    background-position: right;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  .mb-5 {
    margin-bottom:5%;
  }

  .mb-10 {
    margin-bottom:10%;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 1200px){
    .title-user-login{
      padding-top: 15%;
      margin-bottom: -10px;
      font-size: 35px;
    }
  }

  @media screen and (max-width: 1050px){
    .container-login{
      margin-left: 0%;
    }
    .recaptcha {
      margin-left: 6%;
    }
    .background-login{
      display: none;
    }
    .login-content{
      background-image: linear-gradient(to right, #50B2AF,#51989B, #537F87);
    }
  }

  @media screen and (max-width: 960px){
    .container-login{
      margin-left: 0%;
    }
    .recaptcha {
      margin-left: 25%;
    }
    .avatar-login{
      width: 40%;
      height: 40%;
      margin-left: 30%;
    }
  }

  @media screen and (max-width: 600px){
    .container-login{
      margin-left: 0%;
    }
    .background-login{
      display: none;
    }
    .recaptcha {
      margin-left: 15%;
    }
    .avatar-login{
      width: 45%;
      height: 45%;
      margin-left: 27%;
      margin-bottom: -15%;
    }
  }

    @media screen and (max-width: 400px){
    .container-login{
      margin-left: 0%;
    }
    .background-login{
      display: none;
    }
    .recaptcha {
      margin-left: 1%;
    }
    .avatar-login{
      width: 45%;
      height: 45%;
      margin-left: 25%;
      margin-bottom: -15%;
    }
  }

</style>
